import * as React from 'react'
import { IFilter, IPeerGroupTabsProps, IVisualizationState } from '../../lib/http'
import * as ReactHighcharts from 'react-highcharts'
import PanelGraph from 'app/components/tabs/PanelGraph'

export class ExpensesAsPercentOfAssets extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    data: [],
    categories: [],
    filters: { assetLevel: 0 },
    loading: false,
    average: [],
    title: '',
    series: [],
  }

  componentDidMount() {
    ReactHighcharts.Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    })
    this.setState({ data: this.props.data }, () => this.loadSeries(this.props.filters))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    const currentSet = data.find(dataPoint => dataPoint.filterId === filters.assetLevel)
    const filterOutAllFoundations = data.filter(dataPoint => dataPoint.filterId > 0)

    const categories = filterOutAllFoundations.map(dataPoint => dataPoint['InvExp_T_V3_ColName'])
    const averageData = filterOutAllFoundations.map(dataPoint => dataPoint.InvExp_N_V1_InvExpAvg)

    const selectedColor = "#0070C0"
    const nonSelectedColor = "#D9E1F2"

    const seriesData = filterOutAllFoundations.map(dataPoint => dataPoint.filterId === filters.assetLevel ?
      { y: dataPoint.InvExp_N_V1_InvExpMdn, color: selectedColor, filterId: dataPoint.filterId }
      : { y: dataPoint.InvExp_N_V1_InvExpMdn, color: nonSelectedColor, filterId: dataPoint.filterId, borderWidth: 1, borderColor: '#a1a1a1' })

    const title = currentSet ? currentSet['InvExp_T_V1_Vis1Title'] : ''

    if (averageData && averageData.length > 1) {
      averageData[averageData.length - 1] = { y: averageData[averageData.length - 1], dataLabels: { enabled: true, format: 'Average: {y:.0f}' } }
    }

    const series = [
      {
        color: '#0070C0', name: 'Basis Points', data: seriesData, events: {
          click: event => {
            this.props.onChangeFilterId(event.point.filterId)
          }
        }
      },
      { color: '#a1a1a1', name: 'Average', data: averageData, type: 'line', dashStyle: 'ShortDash', lineWidth: 3, marker: { enabled: false }, }
    ]
    this.setState({ categories, title, loading: false, series })

  }

  static getPublicIndexConfig(series, categories, plotLineNumber, title) {
    return {
      chart: { type: 'column' },
      title: {
        text: title
      },
      subtitle: {
        text: '',
        style: {
          "font-size": "15px"
        }
      },
      xAxis: {
        categories
      },
      yAxis: {
        visible: false,
        opposite: false,
        title: '',
        labels: {
          format: '{value}%',
        },
        plotLines: [{
          color: '#a1a1a1',
          dashStyle: 'ShortDash',
          value: plotLineNumber,
          zIndex: 2,
          label: 'Average',
          width: '3'
        }],
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y}',
          }
        },
        line: {
          dataLabels: {
            enabled: false,
            format: 'Average: {y}',
          }
        }
      },
      legend: { enabled: false },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { loading, categories, title, series, plotLineNumber } = this.state
    return (
      <PanelGraph title={''} loading={loading} chartConfig={ExpensesAsPercentOfAssets.getPublicIndexConfig(series, categories, plotLineNumber, title)} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Expenses/ExpensesAsPercentOfAssets/index.tsx